import { render, staticRenderFns } from "./BDzhTable.vue?vue&type=template&id=76c87a7e&scoped=true"
import script from "./BDzhTable.vue?vue&type=script&lang=js"
export * from "./BDzhTable.vue?vue&type=script&lang=js"
import style0 from "./BDzhTable.vue?vue&type=style&index=0&id=76c87a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c87a7e",
  null
  
)

export default component.exports